import { all, call, put, takeEvery } from 'redux-saga/effects';
import {
  ConsultationMasterDataApi,
  CreateConsultationMedicalDetailsApi,
  GetAppoinmentApi,
  GetAppointmentByIdApi,
  getAdminUserApi,
  getAllConsultationApi,
  getDrAvailabilityApi,
  getDrSlotAvailabilityApi,
} from '../../utils/api';
import {
  CONSULTATION_MASTERDATA,
  CREATE_MEDICAL_DETAILS, GET_ADMIN_USER,
  GET_ALL_APPOINMENT,
  GET_APPOINTMENT_BY_ID,
  GET_ALL_CONSULTATION,
  GET_DR_AVAILABILITY,
  GET_DR_SLOT_AVAILABILITY
} from '../storeTypes';
import {
  ConsultationMasterDataSuccess,
  getAdminUserSuccess,
  getAllAppoinmentSuccess,
  getAppointmentByIdSuccess,
  getAllConsultationSuccess,
  getDrAvailabilitySuccess,
  getDrSlotAvailabilitySuccess,
  CreateConsultationMedicalDetailsSuccess,
  CreateConsultationMedicalDetailsFailure
} from '../Actions/AppointmentAction';
import { handleApiResponse } from '../../utils/functions';

const File = 'AppointmentSaga ';

function* getAllConsultationSaga(action) {
  try {
    const response = yield call(getAllConsultationApi, action.payload);
    if (response?.status === 200) {
      yield put(getAllConsultationSuccess(response?.data?.data));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
  }
}
function* getAllAppoinmentSaga(action) {
  try {
    const response = yield call(GetAppoinmentApi, action.payload);
    if (response?.status === 200) {
      yield put(getAllAppoinmentSuccess(response?.data?.data));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
  }
}

function* getAppointmentByIdSaga(action) {
  try {
    const response = yield call(GetAppointmentByIdApi, action.payload);
    if (response?.status === 200) {
      yield put(getAppointmentByIdSuccess(response?.data?.data));
      if (action?.callBack) {
        action?.callBack(response?.data?.data);
      }
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
  }
}

function* getAdminUserSaga(action) {
  try {
    const response = yield call(getAdminUserApi, action.payload);
    if (response?.status === 200) {
      yield put(getAdminUserSuccess(response?.data?.data));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
  }
}

function* getDrAvailabilitySaga(action) {
  try {
    const response = yield call(getDrAvailabilityApi, action.payload);
    if (response?.status === 200) {
      yield put(getDrAvailabilitySuccess(response?.data?.data));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack);
  }
}

function* getDrSlotAvailabilitySaga(action) {
  try {
    const response = yield call(getDrSlotAvailabilityApi, action.payload);
    if (response?.status === 200) {
      yield put(getDrSlotAvailabilitySuccess(response?.data?.data));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack);
  }
}

function* ConsultationMasterDataSaga(action) {
  try {
    const response = yield call(ConsultationMasterDataApi, action.payload);
    if (response?.status === 200) {
      yield put(ConsultationMasterDataSuccess(response?.data?.data));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack);
  }
}

function* CreateConsultationMedicalDetailsSaga(action) {
  try {
    const response = yield call(CreateConsultationMedicalDetailsApi, action.payload);
    // Success status can be 200 or 201
    if (response?.status === 200 || response?.status === 201) {
      yield put(CreateConsultationMedicalDetailsSuccess(response?.data));
      handleApiResponse(response?.status, response?.data, action?.callBack);
    } else {
      yield put(CreateConsultationMedicalDetailsFailure(response?.data));
      handleApiResponse(response?.status, response?.data, action?.callBack);
    }
  } catch (error) {
    yield put(CreateConsultationMedicalDetailsFailure(error?.response?.data));
    handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
  }
}

export function* AppointmentSaga() {
  yield all([
    takeEvery(GET_ALL_CONSULTATION, getAllConsultationSaga),
    takeEvery(GET_ADMIN_USER, getAdminUserSaga),
    takeEvery(GET_ALL_APPOINMENT, getAllAppoinmentSaga),
    takeEvery(GET_APPOINTMENT_BY_ID, getAppointmentByIdSaga),
    takeEvery(GET_DR_AVAILABILITY, getDrAvailabilitySaga),
    takeEvery(GET_DR_SLOT_AVAILABILITY, getDrSlotAvailabilitySaga),
    takeEvery(CONSULTATION_MASTERDATA, ConsultationMasterDataSaga),
    takeEvery(CREATE_MEDICAL_DETAILS, CreateConsultationMedicalDetailsSaga),
  ]);
}
